import { PumpShiftStatusEnum } from '../../models'
import {
  PumpShiftAction,
  PumpShiftState,
  SET_PUMP_SHIFTS,
  SET_PUMP_SHIFTS_LOADED,
  SET_PUMP_SHIFT_FILTER,
  SET_TOTAL_AMOUNT_OF_PUMP_SHIFTS,
  SET_TOTAL_PUMP_SHIFTS,
  SET_TOTAL_VOLUME_OF_PUMP_SHIFTS,
} from '../types'

const initialState: PumpShiftState = {
  pumpShifts: [],
  totalPumpShifts: 0,
  isPumpShiftsLoaded: false,
  totalAmountOfPumpsShift: 0,
  totalVolumeOfPumpsShift: 0,
  pumpShiftFilter: {
    statuses: Object.values(PumpShiftStatusEnum),
    stationName: '',
    stationIds: [],
    pumpName: '',
    shiftName: '',
    pageSize: 15,
    pageIndex: 1,
  },
}

export const pumpShiftReducer = (
  state = initialState,
  action: PumpShiftAction
): PumpShiftState => {
  switch (action.type) {
    case SET_PUMP_SHIFTS:
      return {
        ...state,
        pumpShifts: action.payload,
      }
    case SET_PUMP_SHIFTS_LOADED:
      return {
        ...state,
        isPumpShiftsLoaded: action.payload,
      }
    case SET_PUMP_SHIFT_FILTER:
      return {
        ...state,
        pumpShiftFilter: action.payload,
      }
    case SET_TOTAL_PUMP_SHIFTS:
      return {
        ...state,
        totalPumpShifts: action.payload,
      }
    case SET_TOTAL_VOLUME_OF_PUMP_SHIFTS:
      return {
        ...state,
        totalVolumeOfPumpsShift: action.payload,
      }
    case SET_TOTAL_AMOUNT_OF_PUMP_SHIFTS:
      return {
        ...state,
        totalAmountOfPumpsShift: action.payload,
      }
    default:
      return state
  }
}
